// «Cancelar» con cambios pide confirmación (`estandares_frontend.md` §5; lineamiento UX/UI,
// «Confirmación antes de descartar»). El `Modal` del catálogo ya lo pregunta al cerrar con
// Escape o con el fondo; esto es lo mismo, con el mismo texto, para el botón «Cancelar» del pie.
export const TEXTO_DE_DESCARTE = 'Tienes cambios sin guardar. ¿Salir y descartarlos?';

/** `true` si se puede cerrar: no hay cambios, o la persona confirmó descartarlos. */
export const puedeDescartar = (sucio: boolean): boolean => !sucio || window.confirm(TEXTO_DE_DESCARTE);
